import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { Modal, Text, Button } from '@simplybenefits/sb-ui-library';
import * as notifier from '../../../../actions/notifier.js';
import { helpers } from '@simplybenefits/sb-utils';
import pdfImg from '../../../../assets/pdf.png';

class SubmitReceiptModal extends PureComponent {
    state = {
        photo: this.props.receiptPhoto
    };

    _selectPicture = (files) => {
        const file = new File([ files[0] ], helpers.cleanFilename(files[0].path), { type: files[0].type });
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            this.setState({
                photo: {
                    file,
                    image: reader.result
                }
            });

            this.props.saveData({
                file,
                image: reader.result
            }, 'receiptPhoto');
        };
    };

    _next = () => {
        // if it's a claim that was manually flagged from the dental office then we don't need a receipt
        if (this.props.receiptRequired === false) {
            this.props.next();
            return null;
        }

        if (!this.state.photo || this.state.photo === null) {
            this.props.dispatch(notifier.displayError({ verbiage: 'Please provided a photo of your receipt before continuing.' }));
            return null;
        }

        this.props.next();
        return null;
    };

    render() {
        const styles = {
            image: {
                height: 300,
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            },
            pdf: {
                width: '40%',
                height: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };

        const { photo } = this.state;
        const isPDF = photo?.file?.type === 'application/pdf' || photo?.contentType === 'application/pdf';
        const imageSrc = photo?.image || photo?.url;

        return (
            <Modal
                medium
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={{
                    label: "Next",
                    onClick: this._next
                }}
                onClose={ this.props.onClose }
                loader={ this.props.loader }
                onBack={ this.props.onBack }
            >
                <Text light mediumLarge margin="10px 0 20px 0">
                    {
                        this.props.type === 'HealthSpending' ?
                            'Provide a photo of your claim receipt (Explanation or Coordination of Benefits) to be reimbursed.'
                            :
                            'Provide a photo of your invoice or receipt to be reimbursed.'
                    }
                </Text>

                {
                    photo && isPDF &&
                            <img alt="Receipt" src={ pdfImg } style={ styles.pdf } />
                }

                {
                    photo && !isPDF && imageSrc &&
                            <img alt="Receipt" src={ imageSrc } style={ styles.image } />
                }

                <div style={{ alignSelf: 'center' }}>
                    <Dropzone
                        onDrop={(files) => this._selectPicture(files)}
                        accept="image/png, image/jpeg, image/jpg, application/pdf"
                    >
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div id="dropzone" {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <Button
                                        marginTop={2.5}
                                        marginBottom={2.5}
                                        transparent
                                    >
                                        Select Receipt
                                    </Button>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                </div>

                <Text light tiny>
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>
            </Modal>
        );
    }
}

export default connect()(SubmitReceiptModal);